export default __webpack_public_path__ + "static/media/optical.1ad6bc1c.webp";